export default __webpack_public_path__ + "static/media/tagsIcon.4e1a8abe.svg";